import { JSX } from 'react'
import classes from './AppWrapper.module.sass'
import { Footer } from '../common/components/footer/Footer'
import { useAppWrapper } from './hooks/useAppWrapper'
import { Bar } from '../common/components/bar/Bar'
import { NotificationList } from '../common/components/notificationList/NotificationList'
import { useInitGMap } from '../common/hooks/useInitGMap'
import { Modal } from '../common/components/modal/Modal'
import { Chat } from '../common/components/chat/Chat'
import { selectConnected } from '../store/slices/wsSlice'
import { useSelector, useDispatch } from 'react-redux'
import { IconButton } from '../common/components/iconButton/IconButton'
import arrow_up from '../assets/images/icons/arrow_up.svg'
import { CommonLoader } from '../common/components/commonLoader/CommonLoader'
import { useCommonLoader } from '../common/hooks/useCommonLoader'
import { TelegramLoginForm } from './components/telegramLoginForm/TelegramLoginForm'
import { EmailLoginForm } from './components/emailLoginForm/EmailLoginForm'
import { MaxLoginForm } from './components/maxLoginForm/MaxLoginForm'
import { AUTH_TYPE } from '../common/utils/constants'
import { AuthPrimary } from '../common/types/enums'
import { useTheme } from '../common/hooks/useTheme'
import { selectPayment, closePayment } from '../store/slices/paymentSlice'
import { PaymentForm } from './components/clusterPaymentForm/PaymentForm'
import { StatusBar } from '../common/components/statusBar/StatusBar'
import { selectClusterList } from '../store/slices/clusterListSlice'
import useMetrics from '../common/hooks/useMetrics'
import { useAttach } from '../common/hooks/useAttach'

type Props = {
  children: JSX.Element | JSX.Element[]
}

export const AppWrapper = ({ children }: Props) => {
  useInitGMap()
  const dispatch = useDispatch()
  const {
    loginModalActive,
    setLoginModalState,
    closeStatusMenu,
    closeChatMenu,
    closeFilter,
    closeSort,
    upAction,
    upVisible,
    closeMap,
    attachEmailMode,
    setAttachEmailMode,
    getClusters,
  } = useAppWrapper()

  useMetrics()
  useAttach()

  const { isOpen: paymentModalActive, clusterId } = useSelector(selectPayment)
  const isConnected = useSelector(selectConnected)
  const clusters = useSelector(selectClusterList)
  const { commonLoading } = useCommonLoader()
  useTheme()

  return (
    <div
      onClick={() => {
        closeChatMenu()
        closeStatusMenu()
        closeFilter()
        closeSort()
        closeMap()
      }}
      className={classes.Container}
    >
      <div className={classes.ContentContainer}>
        <Bar />
        <StatusBar isConnected={isConnected} clusters={clusters} />

        <NotificationList />
        {children}
      </div>
      <Footer />
      <Modal modalActive={loginModalActive} setModalActive={setLoginModalState}>
        {attachEmailMode ? (
          <EmailLoginForm
            setModalActive={setLoginModalState}
            attach={true}
            onAttachComplete={() => setAttachEmailMode(false)}
          />
        ) : AUTH_TYPE === AuthPrimary.TELEGRAM ? (
          <TelegramLoginForm
            setModalActive={setLoginModalState}
            onAttachEmail={() => setAttachEmailMode(true)}
          />
        ) : AUTH_TYPE === AuthPrimary.EMAIL ? (
          <EmailLoginForm setModalActive={setLoginModalState} />
        ) : AUTH_TYPE === AuthPrimary.MAX ? (
          <MaxLoginForm setModalActive={setLoginModalState} />
        ) : (
          <></>
        )}
      </Modal>
      <Modal
        modalActive={paymentModalActive}
        setModalActive={() => dispatch(closePayment())}
        yooKassa
      >
        {clusterId ? (
          <PaymentForm
            clusterId={clusterId}
            onSuccess={() => {
              dispatch(closePayment())
              getClusters()
            }}
          />
        ) : (
          <></>
        )}
      </Modal>
      {commonLoading && <CommonLoader />}
       {process.env.REACT_APP_COUNTRY === 'ru' && (
      <Chat />
       )}
      {upVisible && (
        <div className={classes.ArrowUp}>
          <IconButton onClick={upAction} icon={arrow_up} alt="Наверх" display />
        </div>
      )}
    </div>
  )
}
